import type { StoreCard, StoreView } from "./types.js";

export function catalogueCards(view: StoreView): StoreCard[] {
  const cards = [
    ...view.featured,
    ...(view.recommended ? [view.recommended] : []),
    ...view.packs,
    ...view.daily.cards,
    view.daily.mustBuy,
    view.daily.weekly,
    view.daily.monthly,
    ...view.flash,
    ...view.chains,
    ...view.speedups,
    ...view.resources,
    ...view.fabrication,
    ...view.cosmetics,
  ];
  return [...new Map(cards.map((card) => [card.key, card])).values()];
}

/** Short freshness window, cut off sooner when an offer or Berlin daily catalogue ends. */
export function catalogueExpiresAt(view: StoreView, now: number): number {
  const deadlines = [
    view.daily.refresh.resetsAt,
    ...catalogueCards(view).map((card) => card.expiresAt),
  ].filter((value): value is number => value !== null && value > now);
  return Math.min(now + 30_000, ...deadlines);
}
